{{#partial page}}
<div class="p-network-infographic">
	<img width="1140" src="{{@shared.assetsHost}}/img/network/infographics.png?v={{@shared.assetsVersion}}" srcset="{{@shared.assetsHost}}/img/network/infographics@2x.png?v={{@shared.assetsVersion}} 2x">
</div>
{{/partial}}

{{#if !@shared.isServer}}
	{{>page}}
{{else}}
	<!DOCTYPE html>
	<html lang="en">
		<head>
			<meta charset="utf-8">
			<meta name="viewport" content="width=device-width, initial-scale=1">
			<meta name="description" content="jsDelivr uses multiple DNS, CDN, and web hosting providers to deliver the most reliable service possible.">
			<meta name="keywords" content="jsdelivr, cdn, npm, github, js, javascript, free, open source, oss">
			<title>How jsDelivr works</title>
			<link rel="stylesheet" href="{{@shared.assetsHost}}/css/app.css?v={{@shared.assetsVersion}}">
			<link rel="sitemap" href="/sitemap/index.xml" type="application/xml">
		</head>

		<body>
			<div id="page">
				{{>page}}
			</div>

			<script defer data-domain="jsdelivr.com" src="https://datum.jsdelivr.com/js/script.js"></script>
		</body>
	</html>
{{/if}}
